<template>
<div class="container">
  <div class="col-7 col-md-12">
    <h1>Hey {{user.profile.firstname}}!</h1>
    <div v-html="matterinfo">fff</div>
    <p>Welcome!</p>
    <p>Using the PocketLegal service is easy, and starts with two steps. Firstly, answer the questions in the visa tab. Then upload the relevant documents in the documents tab.</p>
    <p>After we review your documents, we will draft the application, then send it to you for a final review before submitting it.</p>
    <h4>Office Details</h4>
    <p>Please contact us at any stage throughout the process. We're here to help!</p>
    <p><i class="fa fa-phone-square" aria-hidden="true"></i> (02) 8385 1451</p>
    <p><i class="fa fa-envelope-o" aria-hidden="true"></i> <a href="mailto:info@pocketlegal.com.au">info@pocketlegal.com.au</a></p>
    <p><i class="fa fa-building" aria-hidden="true"></i> Office: 162 Redfern Street, Redfern 2016, NSW</p>
  </div>
</div>
</template>

<script>
export default {
  name: 'clientHome',
  data () {
    return {}
  },
  created () {
    this.$root.$data.pageTitle = ''
  },
  computed: {
    user () {
      return this.$root.$data.user
    },
    matterinfo () {
      let m = this.$root.$data.client.matters
      if (m.length) {
        return m[0].visatype.info
      } else {
        return ''
      }
    }
  }
}
</script>
<style scoped>
.homeOptions a {
  color: #fff;
  background: linear-gradient(134deg, #3023ae 0%, #c86dd7 100%);
  display: block;
  width: 100%;
  padding: 3em 0;
  text-align: center;
  font-size: 1.3em;
  margin: 0 0 1em 0;
}
.homeOptions a:hover {
  background: #3023ae;
  color: #fff!important;
  text-decoration: none;
}
.homeOptions a i {
  display: block;
  font-size: 1.5em;
  margin: 0 0 0.6em 0
}
i {
  color: #136efb
}
/* FAQ */
.faq-section{
  margin: 0 0 0.6em 0;
  position: relative;
}

/*Hide the paragraphs*/
.faq-section p{
  display: none;
}   

/*Hide the checkboxes */
.faq-section input{
  position: absolute;
  z-index: 2;
  cursor: pointer;
  opacity: 0;         
  display: none\9; /* IE8 and below */
  margin: 0;          
  width: 100%;
  height: 36px;
}

/*Show only the clipped intro */
.faq-section label {
  display: block; 
  color: #999;
  font-size: .85em;
  transition: all .15s ease-out;
  /* Clipping text */
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;     

}

/*If the checkbox is checked, show all paragraphs*/
.faq-section input[type=checkbox]:checked~p{
  display: block;
  color: #444;
  font-size: 1em;
  /* restore clipping defaults */
  text-overflow: clip; 
  white-space: normal;
  overflow: visible;  
}

/*Style the label*/
.faq-section label{
  background: linear-gradient(134deg, #3023ae 0%, #c86dd7 100%);
  color: #fff;
  display: block;
  position: relative;
  padding: 7px 10px;
  transition: all .15s ease-out;          
}

/*Remove text selection when toggle-ing*/
.faq-section label::selection{
  background: none;
}

.faq-section label:hover{
  background: #f5f5f5;
}

/*If the checkbox is checked, style the label accordingly*/
.faq-section input[type=checkbox]:checked~label{
  background: #3023ae;             
}

/*Label's arrow - default state */
.faq-section label::before{
  content: '';
  position: absolute;
  right: 4px;
  top: 50%;
  margin-top: -6px;
  border: 6px solid transparent;
  border-left-color: inherit; 
}

/*Update the right arrow*/
.faq-section input[type=checkbox]:checked~label::before{
  border: 6px solid transparent;
  border-top-color: inherit;
  margin-top: -3px;
  right: 10px;    
}
</style>




// WEBPACK FOOTER //
// clienthome.vue?6e8ee391